const PbxxRecord = require('../pbxx_record')

module.exports = class Note extends PbxxRecord {
  static get class_name() {
    return 'Note'
  }

  publish() {
    return this._mapper().publish(this.id).then((response) => {
      this.published = response.data.published
      return this
    }, (error) => {
      throw(error)
    })
  }

  unpublish() {
    return this._mapper().unpublish(this.id).then((response) => {
      this.published = response.data.published
      return this
    }, (error) => {
      throw(error)
    })
  }
}
